import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, DropdownButton, MenuItem, HelpBlock } from 'react-bootstrap';
import { FormActions, Select } from '../../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, reset, pristine, loading, t, months, years, onSubmit }) => {
	const menuItemInnerStyle = { display: 'block', padding: '10px 20px' };

	const handleReset = () => {
		reset();
		setTimeout(() => handleSubmit());
	};

	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit(values => onSubmit({ ...values }))}>
					<Row>
						<Col sm={2}>
							<Select name='year' data={years} hideEmptyOption={true} label={t('SoftwareFeeReport_Year')} />
						</Col>
						<Col sm={2}>
							<Select name='month' data={months} hideEmptyOption={true} label={t('SoftwareFeeReport_Month')} />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<DropdownButton title={<span>{t('Common_Export')} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret disabled={loading} bsStyle='warning'>
							<MenuItem key='Excel' eventKey='Excel' onSelect={handleSubmit(values => onSubmit({ ...values, exportFormat: 'Excel' }))}>
								<span style={menuItemInnerStyle} >{t('Common_ExportToExcel')}</span>
							</MenuItem>
							<MenuItem key='Xero' eventKey='Xero' onSelect={handleSubmit(values => onSubmit({ ...values, exportFormat: 'Xero' }))} >
								<span style={menuItemInnerStyle} >{t('Common_ExportToXeroCSV')}</span>
							</MenuItem>
						</DropdownButton>
						<Button disabled={pristine || loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'softwareFeeReportFilter' })(withTranslation()(Filter));